import DataMap from 'assets/components/dataMap/DataMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import useApi from 'assets/hooks/api/useApi';
import { getLocales, Language } from 'assets/locales/Locale';
import { compact, uniq, values } from 'lodash';
import Product from 'models/productManagement/product/Model.Product';
import React, { useMemo } from 'react';
import { useDealerProvider } from '../../Dealer.Hooks';
import ProductDocumentTranslation from './Dealer.ProductDocumentTranslation';
import { Fragment } from 'react';

const DealerProductDocumentForm: React.FC<{
  additionalProductIds: number[];
  setAdditionalProductIds: React.Dispatch<React.SetStateAction<number[]>>;
}> = ({ additionalProductIds }) => {
  const { selected } = useDealerProvider();
  const { lang } = getLocales();

  const productIds = useMemo(() => {
    const ids = uniq([...compact(selected?.products?.map((p) => p.id)), ...additionalProductIds]);
    return ids.length ? ids : undefined;
  }, [selected?.products, additionalProductIds]);
  const { payload: productsPayload } = useApi(
    {
      action: Product.list,
      wait: !productIds,
      body: {
        productId: productIds,
      },
    },
    [productIds]
  );
  const products = productsPayload?.data;

  return (
    <>
      <table className={ThemeTableSimple}>
        <DataMap
          data={products}
          render={({ data: product }) =>
            !product.productDocuments.length ? null : (
              <Fragment key={product.id}>
                <thead>
                  <tr>
                    <th>{product.name}</th>
                    <DataMap
                      data={values(Language)}
                      render={({ data: langIsoCode }) => <th key={langIsoCode}>{lang[langIsoCode]}</th>}
                    />
                  </tr>
                </thead>
                <tbody>
                  <DataMap
                    data={product.productDocuments}
                    render={({ data: productDocument }) => {
                      return (
                        <tr key={productDocument.id}>
                          <td>{productDocument.displayInfo.title}</td>
                          <DataMap
                            data={values(Language)}
                            render={({ data: languageIsoCode }) => (
                              <td key={languageIsoCode}>
                                <ProductDocumentTranslation
                                  languageIsoCode={languageIsoCode}
                                  productDocument={productDocument}
                                />
                              </td>
                            )}
                          />
                        </tr>
                      );
                    }}
                  />
                </tbody>
              </Fragment>
            )
          }
        />
      </table>
    </>
  );
};
export default DealerProductDocumentForm;
